import React, { useState } from "react";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import CurriculumStore from "../../../../stores/CurriculumStore";
import { Spinner, Button, PieTimer } from "../../../-common";
import "./ConfirmDeleteCourseModal.scss";

function ConfirmDeleteCourseModal({ curriculum, course, close }) {
  const navigate = useNavigate();
  const { id: curriculumId, title } = curriculum || {};
  const { id, name } = course || {};

  const [deleteEnabled, setDeleteEnabled] = useState(false);
  const enableDelete = () => setDeleteEnabled(true);

  const [deleting, setDeleting] = useState(false);

  const deleteCourse = async () => {
    setDeleting(true);
    await CurriculumStore.deleteCourse({ curriculumId, courseId: id });
    close();
    navigate(`/curriculum/${curriculumId}`);
  };

  const cancelButtonStyles = deleting ? { opacity: 0.1, pointerEvents: "none" } : {};

  const actionButtonStyles = deleting ? { opacity: 0.3, pointerEvents: "none" } : {};
  const actionButtonContent = deleting ? <Spinner /> : "Delete Course";
  const actionButton = deleteEnabled ? (
    <Button type="negative" action={deleteCourse} style={actionButtonStyles}>
      {actionButtonContent}
    </Button>
  ) : (
    <div className="timer-container">
      <PieTimer color="var(--red)" width={24} height={24} duration={3000} onComplete={enableDelete} />
    </div>
  );

  return (
    <div className="confirm-delete-course-modal">
      <div className="content">
        <div className="title">
          Are you sure you want to delete {name} (from {title})?
        </div>
      </div>
      <div className="bottom-buttons">
        <Button action={close} style={cancelButtonStyles}>
          Cancel
        </Button>
        <div className="left-buttons">{actionButton}</div>
      </div>
    </div>
  );
}

export default observer(ConfirmDeleteCourseModal);
